export default "__VITE_ASSET__CTc3iMM2__"